<template>
  <div class="works-page">
    <!-- 顶部横幅 -->
    <div class="works-banner">
      <div class="banner-content">
        <h1>优秀作业展示</h1>
        <p>展示学生创意与才华的窗口</p>
      </div>
    </div>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span> / </span>
        <span>优秀作业</span>
      </div>
    </div>

    <div class="container">
      <!-- 作业筛选 -->
      <section v-if="false" class="works-filter">
        <div class="filter-container">
          <div class="filter-group">
            <label for="department">院系:</label>
            <select id="department" v-model="selectedDepartment">
              <option value="">全部院系</option>
              <option v-for="dept in departments" :key="dept" :value="dept">{{ dept }}</option>
            </select>
          </div>
          <div class="filter-group">
            <label for="course">课程:</label>
            <select id="course" v-model="selectedCourse">
              <option value="">全部课程</option>
              <option v-for="course in courses" :key="course" :value="course">{{ course }}</option>
            </select>
          </div>
          <div class="filter-group">
            <label for="grade">年级:</label>
            <select id="grade" v-model="selectedGrade">
              <option value="">全部年级</option>
              <option v-for="grade in grades" :key="grade" :value="grade">{{ grade }}</option>
            </select>
          </div>
          <div class="filter-group search-group">
            <label for="search">搜索:</label>
            <input
                type="text"
                placeholder="搜索作业名称或学生..."
                v-model="searchQuery"
                @input="handleSearch"
            >
            <i class="fas fa-search"></i>
          </div>
        </div>
      </section>

      <!-- 推荐作业 -->
      <section class="featured-works" v-if="featuredWorks.length > 0">
        <h2 class="section-title">推荐作业</h2>
        <div class="featured-grid">
          <div
              v-for="work in featuredWorks"
              :key="work.id"
              class="featured-card"
              @click="showWorkDetail(work)"
          >
            <div class="featured-image">
              <img :src="work.images[0]" :alt="work.title">
              <div class="featured-badge">推荐</div>
            </div>
            <div class="featured-info">
              <h3>{{ work.title }}</h3>
              <p class="work-meta">
                <span>{{ work.student }}</span>
                <span></span>
                <span>{{ work.department }}</span>
                <span></span>
                <span>{{ work.course }}</span>
              </p>
              <p class="work-desc">{{ work.description }}</p>
              <div class="teacher-recommend" v-if="work.recommendation">
                <i class="fas fa-quote-left"></i>
                <p>{{ work.recommendation }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 作业列表 -->
      <section class="works-list">
        <div class="list-header">
          <h2 class="section-title">作业展示</h2>
          <div class="sort-options">
            <span>排序:</span>
            <button
                :class="{ active: sortBy === 'date' }"
                @click="sortWorks('date')"
            >
              最新 <i class="fas" :class="sortOrder === 'desc' ? 'fa-sort-numeric-down' : 'fa-sort-numeric-up'"></i>
            </button>
            <button
                :class="{ active: sortBy === 'views' }"
                @click="sortWorks('views')"
            >
              热度 <i class="fas" :class="sortOrder === 'desc' ? 'fa-sort-numeric-down' : 'fa-sort-numeric-up'"></i>
            </button>
          </div>
        </div>

        <div class="works-grid">
          <div
              v-for="work in paginatedWorks"
              :key="work.id"
              class="work-card"
              @click="showWorkDetail(work)"
          >
            <div class="work-image">
              <img :src="work.images[0]" :alt="work.title">
              <div class="work-views">
                <i class="fas fa-eye"></i> {{ work.views }}
              </div>
            </div>
            <div class="work-info">
              <h3>{{ work.title }}</h3>
              <p class="work-meta">
                <span>{{ work.student }}</span>
                <!--<span></span>-->
                <span>{{ work.department }}</span>
              </p>
              <p class="work-course">{{ work.course }}</p>
              <div class="work-tags">
                <span v-for="tag in work.tags.slice(0, 3)" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页控制 -->
        <div class="pagination" v-if="filteredWorks.length > itemsPerPage">
          <button
              :disabled="currentPage === 1"
              @click="currentPage--"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <span
              v-for="page in totalPages"
              :key="page"
              :class="{ active: currentPage === page }"
              @click="currentPage = page"
          >
            {{ page }}
          </span>
          <button
              :disabled="currentPage === totalPages"
              @click="currentPage++"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </section>
    </div>

    <!-- 作业详情模态框 -->
    <div v-if="selectedWork" class="work-modal" @click.self="closeModal">
      <div class="modal-content">
        <button class="close-btn" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
        <div class="work-detail">
          <div class="detail-left">
            <div class="work-gallery">
              <div class="main-image">
                <img :src="currentImage" :alt="selectedWork.title">
              </div>
              <div class="thumbnail-list">
                <div
                    v-for="(image, index) in selectedWork.images"
                    :key="index"
                    class="thumbnail"
                    :class="{ active: currentImageIndex === index }"
                    @click="changeImage(index)"
                >
                  <img :src="image" :alt="`${selectedWork.title}-${index}`">
                </div>
              </div>
            </div>
          </div>
          <div class="detail-right">
            <h2>{{ selectedWork.title }}</h2>
            <div class="work-meta">
              <p><strong>学生:</strong> {{ selectedWork.student }}</p>
              <p><strong>院系:</strong> {{ selectedWork.department }}</p>
              <p><strong>课程:</strong> {{ selectedWork.course }}</p>
              <p><strong>年级:</strong> {{ selectedWork.grade }}</p>
              <p><strong>指导老师:</strong> {{ selectedWork.teacher }}</p>
              <p><strong>完成时间:</strong> {{ formatDate(selectedWork.date) }}</p>
              <p><strong>浏览量:</strong> {{ selectedWork.views }}</p>
            </div>

            <div class="work-description">
              <h3>作业描述</h3>
              <p>{{ selectedWork.description }}</p>
            </div>

            <div class="work-tags">
              <h3>标签</h3>
              <div class="tags-list">
                <span v-for="tag in selectedWork.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>

            <div class="teacher-comment" v-if="selectedWork.recommendation">
              <h3>教师评语</h3>
              <div class="comment-content">
                <i class="fas fa-quote-left"></i>
                <p>{{ selectedWork.recommendation }}</p>
                <div class="comment-teacher">
                  <p>- {{ selectedWork.teacher }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorksPage',
  data() {
    return {
      selectedDepartment: '',
      selectedCourse: '',
      selectedGrade: '',
      searchQuery: '',
      sortBy: 'date',
      sortOrder: 'desc',
      currentPage: 1,
      itemsPerPage: 12,
      selectedWork: null,
      currentImageIndex: 0,
      departments: ['素描教研室', '色彩教研室', '速写教研室', '设计教研室', '油画系', '国画系', '雕塑系'],
      courses: ['素描基础', '色彩基础', '速写基础', '创意设计', '油画技法', '中国画创作', '雕塑基础', '平面设计'],
      grades: ['一年级', '二年级', '三年级', '四年级', '研究生'],
      works: [
        {
          id: 1,
          title: '素描静物组合',
          student: '张明',
          department: '素描教研室',
          course: '素描基础',
          grade: '一年级',
          teacher: '李星',
          date: '2023-05-15',
          views: 256,
          description: '本作品通过对静物的深入观察和表现，展现了扎实的造型能力和对明暗关系的敏锐把握。作品注重结构和比例，体积感强，明暗层次丰富。',
          recommendation: '该生对静物的形态和质感把握准确，明暗关系处理得当，展现了良好的绘画基本功和空间感知能力。',
          tags: ['素描', '静物', '写实', '明暗'],
          images: [
            require('@/assets/resources/优秀学员/6.jpg'),
            require('@/assets/resources/优秀学员/7.jpg'),
            require('@/assets/resources/优秀学员/8.jpg')
          ],
          featured: true
        },
        {
          id: 2,
          title: '色彩静物写生',
          student: '李华',
          department: '色彩教研室',
          course: '色彩基础',
          grade: '二年级',
          teacher: '王梦',
          date: '2023-04-28',
          views: 189,
          description: '以静物为主题的色彩写生作品，运用水粉颜料，通过准确的色调和丰富的色彩层次表现静物的质感和空间关系。',
          recommendation: '色彩关系把握准确，色调和谐统一，笔触生动有力，展现了出色的色彩感知能力和表现技巧。',
          tags: ['色彩', '静物', '写生', '水粉'],
          images: [
            require('@/assets/resources/优秀学员/7.jpg'),
            require('@/assets/resources/优秀学员/8.jpg')
          ],
          featured: true
        },
        {
          id: 3,
          title: '人物速写',
          student: '王强',
          department: '速写教研室',
          course: '速写基础',
          grade: '一年级',
          teacher: '张琪',
          date: '2023-06-10',
          views: 145,
          description: '人物速写作品，捕捉人物动态和神态特征，线条简练有力，注重人物的结构和比例，表现了对人体结构的理解和把握。',
          tags: ['速写', '人物', '动态', '线条'],
          images: [
            require('@/assets/resources/优秀学员/6.jpg'),
            require('@/assets/resources/优秀学员/7.jpg'),
            require('@/assets/resources/优秀学员/8.jpg')
          ],
          recommendation: '线条流畅有力，动态感强，对人物比例和结构把握准确，展现了扎实的基本功和敏锐的观察力。'
        },
        {
          id: 4,
          title: '设计创意作品',
          student: '赵芳',
          department: '设计教研室',
          course: '创意设计',
          grade: '三年级',
          teacher: '李校长',
          date: '2023-07-05',
          views: 210,
          description: '创意设计作品，融合传统元素与现代设计理念，色彩鲜明，构图新颖，展现了独特的设计思维和创新能力。',
          tags: ['设计', '创意', '色彩', '构成'],
          images: [
            require('@/assets/resources/优秀学员/6.jpg'),
            require('@/assets/resources/优秀学员/7.jpg')
          ],
          recommendation: '创意独特，构图新颖，色彩搭配大胆而和谐，展现了出色的设计思维和表现能力。',
          featured: true
        },
        {
          id: 5,
          title: '油画风景写生',
          student: '陈明',
          department: '油画系',
          course: '油画技法',
          grade: '三年级',
          teacher: '王教授',
          date: '2023-03-22',
          views: 98,
          description: '户外风景写生作品，运用油画技法表现自然景观的光影变化和空间感，色彩丰富，笔触灵活，充分展现了对油画语言的理解和掌握。',
          tags: ['油画', '风景', '写生', '光影'],
          images: [
            require('@/assets/resources/优秀学员/6.jpg'),
            require('@/assets/resources/优秀学员/8.jpg')
          ]
        },
        {
          id: 6,
          title: '中国画山水',
          student: '李小华',
          department: '国画系',
          course: '中国画创作',
          grade: '四年级',
          teacher: '张教授',
          date: '2023-02-15',
          views: 76,
          description: '传统山水画创作，融合古典技法与现代审美，意境深远，笔墨灵动，展现了对传统文化的理解和创新表达。',
          tags: ['国画', '山水', '传统', '笔墨'],
          images: [
            require('@/assets/resources/优秀学员/7.jpg'),
            require('@/assets/resources/优秀学员/8.jpg')
          ]
        },
        // 可以继续添加更多作业数据...
        {
          id: 6,
          title: '品牌视觉设计',
          student: '陈同学',
          department: '设计系',
          course: '视觉传达',
          grade: '三年级',
          teacher: '周副教授',
          date: '2023-04-15',
          views: 132,
          description: '为虚构咖啡品牌设计的完整视觉识别系统，包括标志、色彩系统、字体应用和延展物料设计。',
          tags: ['品牌设计', '视觉识别', '平面设计', '商业'],
          images: [
            require('@/assets/images/work6.png')
          ]
        },
        {
          id: 7,
          title: '陶艺作品',
          student: '黄同学',
          department: '雕塑系',
          course: '陶瓷艺术',
          grade: '二年级',
          teacher: '吴教授',
          date: '2023-05-05',
          views: 87,
          description: '手工拉坯成型的陶艺作品，结合釉下彩装饰技法，展现了传统工艺与现代审美的结合。',
          tags: ['陶艺', '手工', '传统工艺', '釉彩'],
          images: [
            require('@/assets/images/work7.png'),
            require('@/assets/images/work7-2.png')
          ]
        }
      ]
    }
  },
  computed: {
    featuredWorks() {
      return this.works.filter(work => work.featured)
    },
    filteredWorks() {
      let result = this.works.filter(work => !work.featured) // 非推荐作业

      // 筛选院系
      if (this.selectedDepartment) {
        result = result.filter(work => work.department === this.selectedDepartment)
      }

      // 筛选课程
      if (this.selectedCourse) {
        result = result.filter(work => work.course === this.selectedCourse)
      }

      // 筛选年级
      if (this.selectedGrade) {
        result = result.filter(work => work.grade === this.selectedGrade)
      }

      // 搜索
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        result = result.filter(work =>
            work.title.toLowerCase().includes(query) ||
            work.student.toLowerCase().includes(query) ||
            work.tags.some(tag => tag.toLowerCase().includes(query))
        )
      }

      // 排序
      result = [...result].sort((a, b) => {
        if (this.sortBy === 'date') {
          return this.sortOrder === 'desc'
              ? new Date(b.date) - new Date(a.date)
              : new Date(a.date) - new Date(b.date)
        } else if (this.sortBy === 'views') {
          return this.sortOrder === 'desc'
              ? b.views - a.views
              : a.views - b.views
        }
        return 0
      })

      return result
    },
    paginatedWorks() {
      const start = (this.currentPage - 1) * this.itemsPerPage
      return this.filteredWorks.slice(start, start + this.itemsPerPage)
    },
    totalPages() {
      return Math.ceil(this.filteredWorks.length / this.itemsPerPage)
    },
    currentImage() {
      return this.selectedWork ? this.selectedWork.images[this.currentImageIndex] : ''
    }
  },
  methods: {
    sortWorks(criteria) {
      if (this.sortBy === criteria) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = criteria
        this.sortOrder = 'desc'
      }
    },
    handleSearch() {
      this.currentPage = 1
    },
    showWorkDetail(work) {
      this.selectedWork = work
      this.currentImageIndex = 0
      document.body.style.overflow = 'hidden'
      // 模拟增加浏览量
      work.views++
    },
    closeModal() {
      this.selectedWork = null
      document.body.style.overflow = 'auto'
    },
    changeImage(index) {
      this.currentImageIndex = index
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
    }
  },
  watch: {
    selectedDepartment() {
      this.currentPage = 1
    },
    selectedCourse() {
      this.currentPage = 1
    },
    selectedGrade() {
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
.works-page {
  color: #333;
}

/* 顶部横幅样式 */
.works-banner {
  height: 400px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
  url('@/assets/images/common-banner.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  margin-bottom: 40px;
}

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-content p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 面包屑导航 */
.breadcrumb {
  padding: 15px 0;
  background-color: #f8f9fa;
  margin-bottom: 40px;
}

.breadcrumb a {
  color: var(--default-red-color);
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb span {
  color: #7f8c8d;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  position: relative;
  padding-bottom: 15px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: var(--default-red-color);
}

/* 作业筛选样式 */
.works-filter {
  margin-bottom: 40px;
}

.filter-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.filter-group {
  flex: 1;
  min-width: 200px;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

.filter-group select,
.filter-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.search-group {
  position: relative;
}

.search-group input {
  padding-left: 35px;
}

.search-group i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #7f8c8d;
}

/* 推荐作业样式 */
.featured-works {
  margin-bottom: 60px;
}

.featured-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 30px;
}

.featured-card {
  display: flex;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s;
}

.featured-card:hover {
  transform: translateY(-5px);
}

.featured-image {
  flex: 1;
  min-width: 200px;
  position: relative;
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.featured-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #e74c3c;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: bold;
}

.featured-info {
  flex: 2;
  padding: 20px;
}

.featured-info h3 {
  color: #2c3e50;
  margin-bottom: 10px;
}

.work-meta {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin-bottom: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.work-desc {
  color: #555;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.teacher-recommend {
  background-color: #f8f9fa;
  padding: 15px;
  border-left: 3px solid var(--default-red-color);
  font-style: italic;
  color: #555;
}

.teacher-recommend i {
  color: var(--default-red-color);
  margin-right: 5px;
}

/* 作业列表样式 */
.works-list {
  margin-bottom: 60px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.sort-options {
  display: flex;
  align-items: center;
  gap: 15px;
}

.sort-options span {
  color: #7f8c8d;
}

.sort-options button {
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
}

.sort-options button.active {
  color: var(--default-red-color);
  font-weight: bold;
}

.sort-options button i {
  font-size: 0.8rem;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.work-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s;
  cursor: pointer;
}

.work-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.work-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.work-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}

.work-card:hover .work-image img {
  transform: scale(1.05);
}

.work-views {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
}

.work-views i {
  margin-right: 5px;
}

.work-info {
  padding: 15px;
}

.work-info h3 {
  color: #2c3e50;
  margin-bottom: 5px;
  font-size: 1.1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 3em;
}

.work-meta {
  color: #7f8c8d;
  font-size: 0.9rem;
  margin-bottom: 8px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.work-course {
  color: var(--default-red-color);
  font-size: 0.9rem;
  margin-bottom: 10px;
  font-weight: 500;
}

.work-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.work-tags span {
  background-color: #f1f1f1;
  color: #555;
  font-size: 0.8rem;
  padding: 3px 8px;
  border-radius: 4px;
}

/* 分页样式 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
}

.pagination button {
  width: 36px;
  height: 36px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
  background-color: #f8f9fa;
}

.pagination span {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
}

.pagination span.active {
  background-color: var(--default-red-color);
  color: white;
}

.pagination span:hover:not(.active) {
  background-color: #f8f9fa;
}

/* 作业详情模态框样式 */
.work-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background-color: white;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #7f8c8d;
  cursor: pointer;
  z-index: 10;
}

.work-detail {
  display: flex;
  overflow: hidden;
}

.detail-left {
  flex: 1;
  padding: 30px;
  background-color: #f8f9fa;
}

.work-gallery {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-image {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: white;
}

.thumbnail-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.thumbnail {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  flex-shrink: 0;
}

.thumbnail.active {
  border-color: var(--default-red-color);
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-right {
  flex: 1;
  padding: 30px;
  overflow-y: auto;
}

.detail-right h2 {
  color: #2c3e50;
  margin-bottom: 20px;
}

.work-meta {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.work-meta p {
  color: #555;
}

.work-meta strong {
  color: #2c3e50;
}

.work-description {
  margin-bottom: 30px;
}

.work-description h3 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.work-description p {
  color: #555;
  line-height: 1.8;
}

.work-tags {
  margin-bottom: 30px;
}

.work-tags h3 {
  color: #2c3e50;
  /* margin-bottom: 15px; */
  font-size: 1.2rem;
}

.tags-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.tags-list span {
  background-color: #f1f1f1;
  color: #555;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.9rem;
}

.teacher-comment {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.teacher-comment h3 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.comment-content {
  position: relative;
  padding: 0 20px;
}

.comment-content i {
  position: absolute;
  color: var(--default-red-color);
  font-size: 2rem;
  opacity: 0.2;
}

.comment-content i:first-child {
  top: -10px;
  left: 0;
}

.comment-content p {
  color: #555;
  font-style: italic;
  line-height: 1.8;
  margin-bottom: 15px;
}

.comment-teacher {
  text-align: right;
  color: #7f8c8d;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .featured-grid {
    grid-template-columns: 1fr;
  }

  .work-meta {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 992px) {
  .filter-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .work-detail {
    flex-direction: column;
  }

  .detail-left {
    max-width: 100%;
  }

  .main-image {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .works-banner {
    height: 300px;
  }

  .banner-content h1 {
    font-size: 2.5rem;
  }

  .featured-card {
    flex-direction: column;
  }

  .featured-image {
    min-width: 100%;
    height: 200px;
  }

  .modal-content {
    width: 95%;
  }
}

@media (max-width: 576px) {
  .works-banner {
    height: 250px;
  }

  .banner-content h1 {
    font-size: 2rem;
  }

  .banner-content p {
    font-size: 1.2rem;
  }

  .filter-container {
    grid-template-columns: 1fr;
  }

  .list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .sort-options {
    flex-wrap: wrap;
    gap: 10px;
  }

  .works-grid {
    grid-template-columns: 1fr;
  }

  .main-image {
    height: 250px;
  }
}

/* 动画效果 */
.work-modal {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.work-card, .featured-card {
  transition: transform 0.3s, box-shadow 0.3s;
}
</style>
